import * as React from "react";
const SvgFiRrFerrisWheel = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-ferris-wheel_svg__a)">
      <path
        fill="#062147"
        d="M24 11a3 3 0 0 0-2.84-2.984 9.92 9.92 0 0 0-5.175-5.175A3 3 0 0 0 13 0h-2a3 3 0 0 0-2.985 2.841 9.92 9.92 0 0 0-5.175 5.175 2.985 2.985 0 0 0-.659 5.856 9.96 9.96 0 0 0 5.332 7.069l-.48 1.8a1 1 0 0 0 1.932.517l.434-1.606a9.93 9.93 0 0 0 5.211 0l.428 1.606a1 1 0 0 0 1.932-.516l-.48-1.8a9.97 9.97 0 0 0 5.334-7.07A2.994 2.994 0 0 0 24 11M11 2h2a1 1 0 0 1 0 2h-2a1 1 0 1 1 0-2m-8 8h2a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2m9 10a8 8 0 0 1-2.09-.28l1.7-6.364a.407.407 0 0 1 .788 0l1.7 6.364A8 8 0 0 1 12 20m3.956-1.049-1.63-6.11A2.38 2.38 0 0 0 12 11.054a2.38 2.38 0 0 0-2.327 1.787l-1.629 6.11A7.96 7.96 0 0 1 4.26 14H5a3 3 0 0 0 .081-5.992 8.1 8.1 0 0 1 3.507-3.241A2.99 2.99 0 0 0 11.001 6h2a2.99 2.99 0 0 0 2.412-1.233 8.1 8.1 0 0 1 3.506 3.241A3 3 0 0 0 19 14h.74a7.97 7.97 0 0 1-3.784 4.951M21 12h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-ferris-wheel_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFerrisWheel;
